import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DropdownItem } from 'projects/admin/src/app/models/commonModel';

@Component({
  selector: 'app-external-confirmation-tab',
  templateUrl: './external-confirmation-tab.component.html',
  styleUrls: ['./external-confirmation-tab.component.scss']
})
export class ExternalConfirmationTabComponent implements OnInit, OnChanges {
  licenseContractorsText: string = `Applicant(s) company has an active license issued by the State Board for Licensing Contractors. This is not your local business license (see below). This could include a Contractors License (for projects $25,000 or more), a Home Improvement License (for projects less than $25,000), a Limited Licensed Electrician, or a Limited Licensed Plumber. If you are unsure if your business has one of the licenses, you can search https://verify.tn.gov/. If your business does not have a license from the State Board for Licensing Contractors, please ensure the check box is unchecked.`;
  stillAffiliatedCheckBox: string = `By checking this box, I attest that I am still affiliated with the business under which I originally qualified and I still meet the ownership requirements.`;
  attestToTCACheckBox: string = `By checking this box, I attest that I meet all the requirements for the workers' compensation exemption under T.C.A. §50-6-901 et seq. I understand that any false statement I make on the application is subject to the penalties of perjury set out in T.C.A. §39-16-702.`;
  attestToTCA903CheckBox: string = `By checking this box, I attest that I meet all the requirements for the workers' compensation exemption under T.C.A. §50-6-903 et seq. I understand that any false statement I make on the application is subject to the penalties of perjury set out in T.C.A. §39-16-702.`;
  waveRightsToSueCheckBox: string = `By checking this box, I understand that I waive my right to sue under workers' compensation law if I am injured on a job and have utilized the workers' compensation exemption on that job.`;
  registeredApplicantCheckBox: string = `By checking this box, I attest that I am the applicant registered with the information noted above and I voluntarily choose to revoke my workers' compensation exemption registration. I understand that any false statement I make on the application is subject to the penalties of perjury set out to T.C.A. §39-16-702.`;
  yesHaveInjuryCheckBox: string = `I DO have an employment related injury that occurred while providing services to a person or entity that did not provide coverage under a policy of workers' compensation.`;
  dontHaveInjuryCheckBox: string = `I DO NOT have an employment related injury that occurred while providing services to a person or entity that did not provide coverage under a policy of workers' compensation.`;
  filingDate: string = '';
  applicantName: string = '';

  stillAffCbFtype = ['RENEWAL'];
  stillAffCbQtype = ['RELSECTBUSINESSENT', 'RELSECTSOLEPROP'];
  aTcaCbFtype = ['RENEWAL', 'INITIAL', 'SUBSEQUENT', 'REINSTATE', 'CORRECTION'];
  aTca903CbQtype = ['RELSECTBUSINESSENT', 'RELSECTSOLEPROP'];
  rightSueFtype = [
    'RENEWAL',
    'INITIAL',
    'SUBSEQUENT',
    'REINSTATE',
    'CORRECTION',
  ];
  rightSueQtype = ['RELSECTBUSINESSENT', 'RELSECTSOLEPROP'];
  regApFtype = ['VOLREVOCATION'];
  doHvInjutyFtype = ['VOLREVOCATION'];
  @Input()
  data: any;
  @Input()
  FillingType: any;
  @Input()
  CsPLicense: any;
  @Input()
  ParentForm!: FormGroup;
  @Input()
  ConfirmationTab!: FormGroup;

  @Input()
  QualificationTypes!: DropdownItem[];
  @Input()
  CountyTypes!: DropdownItem[];
  @Input()
  CityTypes!: DropdownItem[];
  @Input()
  StateTypes!: DropdownItem[];
  @Input()
  IsExternal = false;
  dontHaveInjury = false;
  yesHaveInjury = false;
  injuryMode: any;
  @Output() oninjuryModeChanged: EventEmitter<any> = new EventEmitter();
  constructor(
    private formBuilder: FormBuilder
  ) {}
ngOnChanges() {
  console.log(this.CsPLicense);
  // if (this.data?.doHaveInjury != null)
    this.injuryMode = this.data?.doHaveInjury
}
  ngOnInit(): void {}

  getFormattedPhone() {
    let phone = this.data?.contactPhone;
    if (phone && phone.length == 10) {
    }
  }
  onCheck(value: any, event: any) {
    if (!event.checked) value = null;
    this.injuryMode = value;
    this.oninjuryModeChanged.emit(this.injuryMode);
  }
  getApplicantName() {
    var fname = this.data?.firstName;
    var lname = this.data?.lastName;
    return `${fname} ${lname}`;
  }

  getMailingAddress() {
    var addr1 = this.data?.mailingAddress?.address1;
    var addr2 = this.data?.mailingAddress?.address2;
    var zipstate = this.data?.mailingAddress?.formattedCityStateZipCode;
    return `${addr1 ? addr1 + '\n' : ''} ${addr2 ? addr2 + '\n' : ''} 
              ${zipstate}`;
  }

  getPhysicalAddress() {
    var addr1 = this.data?.physicalAddress?.address1;
    var addr2 = this.data?.physicalAddress?.address2;
    var zipstate = this.data?.physicalAddress?.formattedCityStateZipCode;
    return `${addr1 ? addr1 + '\n' : ''} ${addr2 ? addr2 + '\n' : ''} 
              ${zipstate}`;
  }

  getQualificationType() {
    return this.data?.qualificationType?.description;
  }

  getQualificationTypeCode() {
    return this.data?.qualificationType?.code;
  }

  checkAttestTCA() {
    const is903 =
      this.aTcaCbFtype.includes(this.FillingType) &&
      this.aTca903CbQtype.includes(this.getQualificationTypeCode());
    return is903;
  }
}
